import React from "react";

export interface IconEyeProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconEye: React.FC<IconEyeProps> = ({
  width = 38,
  height = 26,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 38 26"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M37.7705 12.0115C34.1928 4.84724 27.11 0 19 0C10.89 0 3.80525 4.85063 0.229548 12.0121C0.0786306 12.3185 0 12.657 0 13.0003C0 13.3437 0.0786306 13.6822 0.229548 13.9885C3.80723 21.1528 10.89 26 19 26C27.11 26 34.1948 21.1494 37.7705 13.9879C37.9214 13.6815 38 13.343 38 12.9997C38 12.6564 37.9214 12.3178 37.7705 12.0115ZM19 22.75C17.1211 22.75 15.2843 22.1782 13.7221 21.1068C12.1598 20.0355 10.9422 18.5127 10.2231 16.7312C9.50409 14.9496 9.31596 12.9892 9.68252 11.0979C10.0491 9.20656 10.9539 7.46927 12.2825 6.10571C13.6111 4.74215 15.3038 3.81355 17.1466 3.43734C18.9895 3.06114 20.8996 3.25422 22.6355 3.99217C24.3714 4.73013 25.8551 5.97981 26.899 7.58319C27.9429 9.18657 28.5 11.0716 28.5 13C28.5006 14.2806 28.2553 15.5487 27.7781 16.7319C27.3009 17.9151 26.6012 18.9902 25.7189 19.8957C24.8366 20.8012 23.7891 21.5193 22.6362 22.0091C21.4834 22.4989 20.2477 22.7506 19 22.75ZM19 6.5C18.4347 6.50811 17.8731 6.59442 17.3302 6.75661C17.7777 7.38066 17.9924 8.14862 17.9354 8.92121C17.8785 9.6938 17.5537 10.4199 17.0198 10.9677C16.486 11.5156 15.7786 11.849 15.0258 11.9074C14.273 11.9659 13.5247 11.7455 12.9167 11.2863C12.5704 12.5955 12.6329 13.9832 13.0954 15.254C13.5578 16.5248 14.397 17.6148 15.4946 18.3706C16.5923 19.1263 17.8933 19.5098 19.2144 19.467C20.5355 19.4241 21.8103 18.9572 22.8593 18.1318C23.9083 17.3065 24.6787 16.1643 25.0621 14.866C25.4455 13.5678 25.4225 12.1788 24.9964 10.8947C24.5704 9.6105 23.7626 8.4958 22.687 7.70745C21.6113 6.9191 20.3218 6.49681 19 6.5Z" />
  </svg>
);
